const FinancialOperationTypes = {
  BALANCE: 'balance',
  FEE: 'fee',
  MISCELLANEOUS: 'miscellaneous',
};

module.exports = FinancialOperationTypes;
